import React, { useEffect, useState } from 'react';
import { makeStyles } from '@mui/styles';
import { CircularProgress } from '@mui/material';
import { useIntl } from 'react-intl';
import { Link, useParams } from 'react-router-dom';

import { toAbsoluteUrl } from '../../../../_base';
import { getPublicDoc } from '../../../crud/docs.crud';
import { getDocFromPathname } from './utils';

const useStyles = makeStyles((theme: any) => ({
  root: {
    minHeight: '100vh',
    backgroundColor: '#f2f3f8',
    padding: 30,
    [theme.breakpoints.down('sm')]: {
      padding: 12,
    },
  },
  header: {
    maxWidth: 1000,
    margin: '0 auto 20px',
  },
  container: {
    maxWidth: 1000,
    margin: '0 auto',
    backgroundColor: '#fff',
    padding: 30,
    borderRadius: 4,
    [theme.breakpoints.down('sm')]: {
      padding: 16,
    },
  },
  title: {
    marginBottom: 20,
  },
  content: {
    minHeight: 400,
    color: 'black',
    overflowWrap: 'break-word',
    '& img': {
      maxWidth: '100%',
    },
  },
  loader: {
    minHeight: 400,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

interface IDocument {
  code: string;
  name: string;
  text: string;
  public: boolean;
  id?: number;
}

function ReadDocPage() {
  const classes = useStyles();
  const intl = useIntl();
  const [userDocument, setDocument] = useState<IDocument | null>(null);
  const [loading, setLoading] = useState(false);

  const { type } = useParams();

  const document = getDocFromPathname(type || '', intl);

  useEffect(() => {
    window.document.title = document.name;
  }, [document.name]);

  useEffect(() => {
    setLoading(true);
    getPublicDoc(document.code, intl.locale)
      .then(({ data: requestData }) => {
        setDocument(requestData.data);
        setLoading(false);
      })
      .catch(() => {
        setDocument(null);
        setLoading(false);
      });
  }, [document.code, intl.locale]);

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <Link to='/'>
          <img
            alt=''
            src={toAbsoluteUrl('/media/logos/main-logo.png')}
            style={{ width: 164, height: 32 }}
          />
        </Link>
      </div>
      <div className={classes.container}>
        <h3 className={classes.title}>{document.name}</h3>
        {loading ? (
          <div className={classes.loader}>
            <CircularProgress size={20} />
          </div>
        ) : (
          <div
            className={classes.content}
            dangerouslySetInnerHTML={{ __html: userDocument?.text || '' }}
          />
        )}
      </div>
    </div>
  );
}

export default ReadDocPage;
